export default "__VITE_ASSET__BtvpPG3K__"